export default __webpack_public_path__ + "static/media/sell (2).2f891617.png";